import { defineStore } from 'pinia';
import { ApplicationScope, ApplicationScopeFromJSON } from '~/api-client';


interface State {
  _tenant: ApplicationScope;
}

export const useTenantStore = defineStore('tenant', {
  state: (): State => ({
    _tenant: ApplicationScope.MyDb,
  }),

  getters: {
    isMyDb: (state) => (state._tenant === ApplicationScope.MyDb),
    getTenant: (state) => (state._tenant),
  },
  actions: {
    async initialize(tenant: string) {
      // tenant initialized

      this.$state._tenant = ApplicationScopeFromJSON(tenant);
    },
  },
});
